import React from "react";
import Moment from "react-moment";
import { CompanyHelper } from "../company/Company.Helper";
import { CompanyImage } from "../company/Company.Image";
import { Link } from "../links/Link";
import { ListItemProps } from "../list/List";
import { Experience } from "../user/User";

export function UserExperienceListItem(props: ListItemProps) {
  let experience = props.item as Experience;
  return (
    <div className="UserListItem">
      <div className="row" key={experience.id}>
        <div className="col">
          <div className="media">
            <Link
              href={CompanyHelper.getViewUrl(experience.company)}
              className="text-decoration-none"
              target="_blank"
            >
              <CompanyImage company={experience.company} />
            </Link>
            <div className="media-body pl-2">
              <Link
                href={CompanyHelper.getViewUrl(experience.company)}
                className="text-decoration-none text-dark"
                target="_blank"
              >
                <h6 className="mb-0">{experience.company.dl}</h6>
              </Link>
              <p className="font-weight-light mb-0">
                {experience.designation.dl}
              </p>
              <div className="text-muted font-weight-light font-size-sm">
                <small>
                  <Moment format="MMM YYYY">{experience.startDate}</Moment> -{" "}
                  {experience.endDate ? (
                    <Moment format="MMM YYYY">{experience.endDate}</Moment>
                  ) : (
                    "Present"
                  )}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
    </div>
  );
}
